import { render, staticRenderFns } from "./ClinicApp.vue?vue&type=template&id=08021263"
import script from "./ClinicApp.vue?vue&type=script&lang=js"
export * from "./ClinicApp.vue?vue&type=script&lang=js"
import style0 from "./ClinicApp.vue?vue&type=style&index=0&id=08021263&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports